import { CommunicationWorkflowTargetOrderBySchema } from '../../generic/communication-workflow-target-order-by/communication-workflow-target-order-by-schema';

export class CommunicationWorkflowTargetOrderByExplicitSchema extends CommunicationWorkflowTargetOrderBySchema {}
